import { NativeDateAdapter } from '@angular/material/core';
import moment from 'moment/moment';

// Overrides NativeDateAdapter's today() so the Show from/Show until picker's own calendar/time-
// spinner "today" default reflects the actual current UTC clock, not the browser's local one —
// the one thing the native <input type="datetime-local"> element this replaced could never be
// made to do (no attribute/API exists to change what a native datetime-local popup treats as
// "now"). Under this form's "STRICT LITERAL UTC RULE" (see alert-form.component.ts), a Date's
// LOCAL fields ARE the literal UTC digits, so "today in UTC" is built by placing new Date()'s
// UTC fields into a Date's LOCAL constructor slots — the exact same trick toUtcInputValue/
// toUtcIso use for strings, just producing a Date instead.
//
// getFirstDayOfWeek()/format() are copied from CustomDateAdapter (see
// src/app/config/date-adapter/custom-ngx-date-adapter-provider.ts, the app-wide adapter) purely
// so this picker still looks/behaves like every other Material picker in the app — this
// component needs its own DateAdapter only for the today() override above, and Angular DI takes
// just the last provider registered for a token, not a chain of them, so the app-wide one can't
// be reused directly.
export class AlertScheduleDateAdapter extends NativeDateAdapter {
  override getFirstDayOfWeek(): number {
    return 1;
  }

  override format(date: Date, displayFormat: object): string {
    return moment(date).format(displayFormat.toString());
  }

  override today(): Date {
    const now = new Date();
    return new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes());
  }
}
